import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-reason-feedback',
  templateUrl: './edit-reason-feedback.component.html',
  styleUrls: ['./edit-reason-feedback.component.scss'],
})
export class EditReasonFeedbackComponent implements OnInit {
  public feedback = '';
  public title = '';
  public reason = '';

  constructor(private dialogRef: MatDialogRef<EditReasonFeedbackComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    const isNewPayform = _.get(data, 'isNewPayform', false);
    if (isNewPayform) {
      this.title = 'Create New';
      this.reason = 'creating';
    } else {
      this.title = 'Edit';
      this.reason = 'editing';
    }
  }

  ngOnInit() {}

  cancelClicked() {
    this.dialogRef.close();
  }

  saveClicked() {
    this.dialogRef.close(this.feedback);
  }
}
